// The Main Site Object
window.Site = {

    productsNavigationButtons : document.querySelectorAll('.products-navigation-button'),
    productsButtons           : document.querySelectorAll('.product-thumbnail'),
    productsCloseButtons      : document.querySelectorAll('.product-close'),

    // Init Function
    liftoff : () => {
        //Site.onClickRemoveCookieBanner()
        //Site.onLoadDisplayCookieBanner()

        Site.showProductsSection()
        Site.showProductPage()
        Site.hideProductPage()
        Site.Slider.selectSpecificSlide()
        Site.Slider.setTimer()

        Site.slideProducts()
    },

    // Generate The Cookie Banner
    onClickRemoveCookieBanner : () => {

        if (!Site.cookieBannerButton) return;

        Site.cookieBannerButton.addEventListener('click' , () => {

            if (localStorage.banner !== 'displayed')
                localStorage.banner = 'displayed';

            // Remove The Banner
            document.querySelector('.gocciola').remove();

        })
    },

    // We need to create and display the cookie banner
    onLoadDisplayCookieBanner : () => {

        if (localStorage.banner !== 'displayed') {
            
            // Create the banner DOM 
            Site.banner = document.createElement('div');
            Site.banner.classList.add('gocciola');

            // The Left Column
            Site.bannerText = document.createElement('div');
            Site.bannerText.classList.add('gocciola-text');

            // The Right Column
            Site.bannerButton = document.createElement('div');
            Site.bannerButton.classList.add('gocciola-button');


            // We need to create the content for the two columns
            Site.bannerTextContent  = document.createElement('p')
            Site.bannerButtonContent = document.createElement('button')

            // Set the text message
            Site.bannerTextContent.innerHTML  = "We use cookies"
            Site.bannerButtonContent.innerHTML = "Ok"

            // Append the two columns to the main banner
            Site.bannerText.appendChild(Site.bannerLeftContent)
            Site.bannerButton.appendChild(Site.bannerRightContent)

            // Append the two columns to the main banner
            Site.banner.appendChild(Site.bannerText)
            Site.banner.appendChild(Site.bannerButton)

            // Append the banner to the body
            document.body.appendChild(Site.banner);

        }

    },

    slideProducts : () => {
        let config = {
            cellSelector    : '.product-thumbnail-wrapper',
            pageDots        : false,
            contain         : false,
            prevNextButtons : true,
            cellAlign       : 'left',
            setGallerySize  : false,
            imagesLoaded    : true,
            watchCSS        : true,
            arrowShape      : { 
              x0: 30,
              x1: 60, y1: 25,
              x2: 60, y2: 15,
              x3: 60
            }
        }

        Site.flickityRed   = new Flickity('#red'   , config);
        Site.flickityWhite = new Flickity('#white' , config);

    },

    // Show the correct products section
    showProductsSection : () => {
        Site.productsNavigationButtons.forEach(button => {
            button.addEventListener('click' , () => {

                // Remove the active classes
                document.querySelector('.products-navigation-button.active').classList.remove('active')
                document.querySelector('.products-section.active').classList.remove('active')

                button.classList.add('active')
                document.getElementById(button.value).classList.add('active')
                document.getElementById(button.value).scrollIntoView();

                if (button.value == 'red') {
                    Site.flickityRed.resize()
                }

                if (button.value == 'white') {
                    Site.flickityWhite.resize()
                }

            })
        })
    },

    showProductPage : () => {
        Site.productsButtons.forEach(button => {
            button.addEventListener('click' , event => {
                document.getElementById(button.dataset.id).classList.add('active')
                document.body.style.overflow = 'hidden'
            })
        })
    },

    hideProductPage : () => {
        Site.productsCloseButtons.forEach(button => {
            button.addEventListener('click' , event => {
                button.parentElement.parentElement.classList.remove('active')
                document.body.style.overflow = null
            })
        })
    },

    Slider : {

        slides       : document.querySelectorAll('.intro-gallery-image'),
        slideActive  : document.querySelector('.active-gallery-image'),
        bullets      : document.querySelectorAll('.intro-bullet'),
        bulletActive : document.querySelector('.active-bullet'),
        timer        : null,

        advanceSlide : () => {

            Site.Slider.slideActive.classList.remove('active-gallery-image')
            Site.Slider.slideActive = Site.Slider.slideActive.nextElementSibling ?? Site.Slider.slideActive.parentElement.firstElementChild
            Site.Slider.slideActive.classList.add('active-gallery-image')

            Site.Slider.bulletActive.classList.remove('active-bullet')
            Site.Slider.bulletActive = Site.Slider.bulletActive.nextElementSibling ?? Site.Slider.bulletActive.parentElement.firstElementChild
            Site.Slider.bulletActive.classList.add('active-bullet')

        },

        setTimer : () => {
            Site.Slider.timer = setInterval(function(){Site.Slider.advanceSlide()} , 5000)
        },

        selectSpecificSlide : () => {

            Site.Slider.bullets.forEach(bullet => {
                bullet.addEventListener('click' , () => {

                    Site.Slider.bulletActive.classList.remove('active-bullet')
                    Site.Slider.bulletActive = bullet
                    Site.Slider.bulletActive.classList.add('active-bullet')

                    Site.Slider.slideActive.classList.remove('active-gallery-image')
                    Site.Slider.slideActive = document.getElementById(`index-${bullet.value}`)
                    Site.Slider.slideActive.classList.add('active-gallery-image')


                    clearInterval(Site.Slider.timer)
                    Site.Slider.setTimer()

                })
            })

        }

    },

    initMap : () => {

        let map = new google.maps.Map(document.getElementById("map"), {
            center         : { lat: 45.807267971206365, lng: 13.353026768686409 },
            mapId : 'db1cf6267e034a15',
            zoom           : 17,
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: true,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false
        });

        //const marker = new google.maps.marker.AdvancedMarkerElement({
        //    map,
        //    position: {lat: 45.80577966318389, lng: 13.354904299266476},
        //});


    }

}

//window.initMap = Site.initMap

// Launch The Script
Site.liftoff()



async function createMap() {

  // Request needed libraries.
  const { Map } = await google.maps.importLibrary("maps");
  const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

    const map = new Map(document.getElementById("map"), {
        center         : { lat: 45.807267971206365, lng: 13.353026768686409 },
        mapId : 'db1cf6267e034a15',
        zoom           : 17,
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: true,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false
    });

  const marker = new AdvancedMarkerElement({
    map,
    position: { lat: 45.80577966318389, lng: 13.354904299266476 },
  });
}

window.initMap = createMap
